import { ImportAnswerCard } from './ImportAnswerCard';
export default ImportAnswerCard;
